/* eslint-disable camelcase */
import React, {
  useState,
  useEffect,
} from 'react';
import i18n from 'i18next';

import {
  Flex,
  Text,
} from 'web-styled';
import {
  Icon,
} from 'web-components';

import * as S from './styled';

type Props = {
  indent?: number,
  treeData: any,
  /* Add a Checkbox before the treeNodes */
  checkable?: boolean,
  initialState?: boolean,
  onSelect: { (treeData: any): void },
};

const Tree = ({
  indent,
  treeData,
  checkable,
  initialState,
  onSelect,
}: Props) => {
  const [isOpen, setOpen] = useState(initialState);

  useEffect(() => {
    // make the first one selected if there is no checkable mode and not selected
    if (treeData?.id && !checkable && !treeData.selected) {
      onSelect(treeData);
    }
  }, [treeData?.id, checkable]);

  if (!treeData?.id) return null;

  const notEmpty = treeData.children?.length > 0;
  const disabled = treeData.isFolder && !notEmpty;
  const highlight = checkable
    ? treeData.children?.some(item => item.selected)
    : treeData.selected;

  const handleOnClick = () => {
    if (treeData.isFolder && notEmpty) {
      setOpen(!isOpen);
      return;
    }

    if (checkable && treeData.isFolder) return;

    onSelect(treeData);
  };

  return (
    <Flex
      column
      shrink="0"
      width="100%"
      spacing={5}
      style={{
        paddingLeft: indent,
      }}
    >
      <S.Tree
        disabled={disabled}
        highlight={highlight}
        onClick={handleOnClick}
      >
        <Flex
          align="center"
          width="29px"
          shrink="0"
          spacing={5}
          justify="flex-end"
        >
          {treeData.isFolder ? (
            <>
              {notEmpty && (
                <Icon
                  size="16px"
                  type={`fas fa-angle-${isOpen ? 'down' : 'right'}`}
                />
              )}
              <Icon type="far fa-folder" />
            </>
          ) : (
            <Icon
              color={treeData.selected ? 'link' : '#808080'}
              type={`far fa-${treeData.selected ? 'check-' : ''}square`}
            />
          )}
        </Flex>
        <Text
          color={disabled ? '#b3b3b3' : '#808080'}
        >
          {treeData.is_root ? i18n.t(treeData.name) : treeData.name}
        </Text>
      </S.Tree>
      {isOpen && notEmpty && (
        <Flex
          column
          shrink="0"
          spacing={10}
          width="100%"
        >
          {treeData.children.map(f => (
            <Tree
              key={f.id}
              indent={20}
              treeData={f}
              checkable={checkable}
              onSelect={onSelect}
            />
          ))}
        </Flex>
      )}
    </Flex>
  );
};

Tree.defaultProps = {
  indent: 0,
  checkable: false,
  initialState: false,
};

export default Tree;
